{
  "title": "Sign in",
  "passkey": "Sign in with a passkey",
  "passkeyHint": "Face ID, Touch ID, Windows Hello or a security key.",
  "or": "or with a password",
  "email": "E-mail",
  "password": "Password",
  "submit": "Sign in",
  "codeTitle": "Two-step verification",
  "codeLead": "Enter the 6-digit code from your authenticator app.",
  "code": "Code",
  "useRecovery": "Use a recovery code instead",
  "useTotp": "Use the authenticator app",
  "recoveryCode": "Recovery code",
  "verify": "Verify",
  "passkeyCancelled": "The passkey request was cancelled."
}
